import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  get_mentor_kanbanboard_data_action,
  get_job_details_hiring_manager_action,
  get_assigned_interview_kit_job_action,
  assign_interview_kit_job_action,
  get_all_published_interview_kit_data_action,
  update_applicant_profile_status_kanboard_hiring_manager_action,
  get_suggested_candidates_hiring_manager_action,
  search_candidate_kanban_board_user_action,
  get_assigned_candidates_kanban_action,
  get_calendar_event_lists_action,
  assign_event_to_job_action,
} from "../../../redux/_actions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

const columnsData = {
  applied: {
    name: "APPLIED",
    items: [],
    serialNumber: "1",
    label: "label-blue",
    loading: true,
    emptyState: {
      title: "No Candidates Applied Yet",
      label: "Once candidates apply, they'll appear here for your review.",
    },
  },
  assessment: {
    name: "ASSESSMENT",
    items: [],
    serialNumber: "2",
    label: "label-light-green",
    loading: true,
    emptyState: {
      title: "No Candidates in Assessment Stage",
      label:
        "Candidates who have completed their applications and  assessments will be shown here.",
    },
  },
  interview: {
    name: "INTERVIEW",
    items: [],
    serialNumber: "3",
    label: "label-voilet",
    loading: true,
    emptyState: {
      title: "No Candidates Scheduled for Interview",
      label:
        "Schedule interviews with candidates who have passed the assessment stage.",
    },
  },
  offer: {
    name: "OFFER",
    items: [],
    serialNumber: "4",
    label: "label-yellow",
    loading: true,
    emptyState: {
      title: "No Offers Extended Yet",
      label:
        "Extend offers to the most qualified candidates to move them to the next stage.",
    },
  },
  hired: {
    name: "HIRED",
    items: [],
    serialNumber: "5",
    label: "label-green",
    loading: true,
    emptyState: {
      title: "No Offers Extended Yet",
      label: "Celebrate success by moving hired candidates to this stage.",
    },
  },
  rejected: {
    name: "REJECTED",
    items: [],
    serialNumber: "6",
    label: "label-red",
    loading: true,
    emptyState: {
      title: "No Candidates Rejected Yet",
      label:
        "Candidates who were not selected for the position will be listed here.",
    },
  },
};

function useApplicantKanboard() {
  const [columns, setColumns] = useState(columnsData);
  const [loading, setLoading] = useState(true);
  const [interviewKitsLoading, setInterviewKitsLoading] = useState(true);
  const [allInterviewKits, setAllInterviewKits] = useState([]);
  const [showAllInterviewKits, setShowAllInterviewKits] = useState(false);
  const [jobId, setjobId] = useState(null);
  const [jobDetails, setJobDetails] = useState({});
  const [assignedInterviewKit, setAssignedInterviewKit] = useState({});
  const [assignInterviewkitLoading, setAssignInterviewkitLoading] =
    useState(false);
  const [suggestedCandidatesLoading, setSuggestedCandidatesLoading] =
    useState(false);
  const [suggestedCandidates, setSuggestedCandidates] = useState({});
  const [candidateKanbanSearchLoading, setCandidateKanbanSearchLoading] =
    useState(false);
  const [candidateKanbanSearch, setCandidateKanbanSearch] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [assignedCandidates, setAssignedCandidates] = useState([]);
  const [assignedCandidatesLoading, setAssignedCandidatesLoading] =
    useState(false);

  const [scheduleInterviewModal, setscheduleInterviewModal] = useState(false);
  const [calendarEventLists, setCalendarEventLists] = useState([]);
  const [lastElement, setLastElement] = useState(null);
  const [assessmentValues, setAssessmentValues] = useState(null);
  const [interviewValues, setInterviewValues] = useState(null);
  const [offerValues, setOfferValues] = useState(null);
  const [listView, setListView] = useState(true);
  const [toggleView, setToggleView] = useState(true);
  const [candidatesList, setCandidatesList] = useState({});
  const [currentTab, setCurrentTab] = useState("applied");
  const [stageLoading, setStageLoading] = useState(false);
  const [userType, setUserType] = useState(null);

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  const { status, filteredList } = useSelector(
    (state) => state.get_mentor_kanbanboard_data_reducer
  );

  const { jobDetailsData } = useSelector(
    (state) => state.get_job_details_hiring_manager_reducer
  );
  const { allPublishedInterviewKitsData } = useSelector(
    (state) => state.get_all_published__interview_kit_data_reducer
  );

  const { interviewKitAssignedData } = useSelector(
    (state) => state.get_assigned_interview_kit_job_reducer
  );

  const { suggestedCandidatesData } = useSelector(
    (state) => state.get_suggested_candidates_hiring_manager_reducer
  );

  const { candidateKanbanSearchData } = useSelector(
    (state) => state.search_candidate_kanban_board_user_reducer
  );

  const { assignedCandiatesList } = useSelector(
    (state) => state.get_assigned_candidates_kanban_reducer
  );
  const { calendarEventListsData } = useSelector(
    (state) => state.get_calendar_event_lists_data_reducer
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchInputRef = useRef();
  const params = useParams();

  useEffect(() => {
    let { id } = params;
    const callApi = async () => {
      currentTabHandler(currentTab);
      if (listView) {
        await callCandidateListApi(id, currentTab);
      } else {
        for (let i in columnsData) {
          await callFilteredListApi(id, i);
        }
      }
    };
    getAssignedInterviewkit(id);
    callApi();
  }, [params,currentTab , listView]);

  useEffect(() => {
    let job_id = location.state.id;

    if (job_id !== null) {
      setjobId(job_id);
      setLoading(true);
      callJobDetailsApi(job_id);
    }
  }, []);

  useEffect(() => {
    if (userMetaData?.id) {
      let user_role = userMetaData?.role;

      setUserType(user_role);
    }
  }, [userMetaData]);

  //set filtered data
  useEffect(() => {
    setJobDetails(jobDetailsData);
  }, [jobDetailsData]);

  useEffect(() => {
    if (interviewKitAssignedData?.data) {
      setAssignedInterviewKit(interviewKitAssignedData?.data[0]);
    } else setAssignedInterviewKit({});
  }, [interviewKitAssignedData]);
  //set filtered data
  useEffect(() => {
    if (jobDetailsData?.data) {
      let results = jobDetailsData.data?.skill_names;
      if (results && results.length > 0) {
        getSuggestedCandidatesApi(results);
      }
    }
  }, [jobDetailsData]);

  // set filtered data to kanboard columns
  useEffect(() => {
    if (filteredList && status) {
      let data = {
        ...columns,
        [status]: {
          ...columns[status],
          items: filteredList?.data?.results,
          loading: false,
        },
      };
      setColumns(data);
      if (status === "assessment")
        setAssessmentValues(filteredList?.data?.results);
      if (status === "interview")
        setInterviewValues(filteredList?.data?.results);
      if (status === "offer") setOfferValues(filteredList?.data?.results);
    }
  }, [status, filteredList]);

  useEffect(() => {
    if (allPublishedInterviewKitsData?.data) {
      setAllInterviewKits(allPublishedInterviewKitsData.data?.results);
    }
  }, [allPublishedInterviewKitsData]);
  useEffect(() => {
    if (suggestedCandidatesData?.data) {
      let results = suggestedCandidatesData?.data;
      setSuggestedCandidates(results);
    }
  }, [suggestedCandidatesData]);

  useEffect(() => {
    if (candidateKanbanSearchData?.data) {
      setCandidateKanbanSearch(candidateKanbanSearchData?.data);
    }
  }, [candidateKanbanSearchData]);

  useEffect(() => {
    if (assignedCandiatesList?.data) {
      let results = assignedCandiatesList?.data?.results;
      setAssignedCandidates(results);
    }
  }, [assignedCandiatesList]);

  useEffect(() => {
    if (calendarEventListsData?.data) {
      let data = calendarEventListsData.data?.results;
      let results = calendarEventLists;
      data.forEach((newItem) => {
        if (!results.find((item) => item.id === newItem.id)) {
          results.push(newItem);
        }
      });
      setCalendarEventLists(results);
      // setNextPage(calendarEventListsData?.data.next);
    }
  }, [calendarEventListsData]);

  const currentTabHandler = (tabName) => {
    setCurrentTab(tabName);
  };

  // get job details
  const callJobDetailsApi = async (job_id) => {
    await dispatch(get_job_details_hiring_manager_action(job_id));
    setLoading(false);
  };

  // get filtered lists
  const callFilteredListApi = async (job_id, status) => {
    await dispatch(get_mentor_kanbanboard_data_action(job_id, status));
    columns[status].loading = false;
  };

  const callCandidateListApi = async (job_id, currentTab) => {
    setStageLoading(true);
    let data = await dispatch(get_mentor_kanbanboard_data_action(job_id, currentTab));
    setCandidatesList(data?.data);
    setStageLoading(false);
  }

  const getAssignedInterviewkit = async (job_id) => {
    setLoading(true);
    await dispatch(get_assigned_interview_kit_job_action(job_id));
    setLoading(false);
  };

  const getSuggestedCandidatesApi = async (skills) => {
    setSuggestedCandidatesLoading(true);
    await dispatch(
      get_suggested_candidates_hiring_manager_action({ skills: skills })
    );
    setSuggestedCandidatesLoading(false);
  };

  // kanboard drag and drop add/delete
  const removeFromList = (list, index) => {
    const result = list;
    const [removed] = result.items.splice(index, 1);
    return [removed, result];
  };

  const addToList = (list, index, element) => {
    const result = list;
    result.items.splice(index, 0, element);
    return result;
  };

  const onDragEnd = (result) => {
    let destination = result?.destination && result.destination?.droppableId;
    let source = result?.source && result.source?.droppableId;

    if (!result.destination) {
      return;
    }
    if (
      destination === "assessment" &&
      jobDetails?.data?.assigned_assessment_kit === null
    ) {
      showWarningMessage("Please assign an assessment kit to proceed");

      return;
    }

    if (
      destination === "interview" &&
      jobDetails?.data?.event_assigned === null
    ) {
      showWarningMessage("Please assign an event to proceed");
      return;
    }

    if (
      source === "applied" ||
      source === "assessment" ||
      source === "interview"
    ) {
      if (
        destination === "applied" ||
        destination === "assessment" ||
        destination === "interview"
      ) {
        const listCopy = { ...columns };

        const sourceList = listCopy[result.source.droppableId];

        const [removedElement, newSourceList] = removeFromList(
          sourceList,
          result.source.index
        );

        listCopy[result.source.droppableId] = newSourceList;
        const destinationList = listCopy[result.destination.droppableId];
        listCopy[result.destination.droppableId] = addToList(
          destinationList,
          result.destination.index,
          removedElement
        );
        setColumns(listCopy);

        if (destination !== source) {
          updateApplicantProfileStatus(
            removedElement.id,
            result.destination.droppableId,
            result.source.droppableId
          );
        }
      } else
        showWarningMessage(
          "Action not allowed. Only Hiring Managers can do this"
        );
      return;
    } else {
      showWarningMessage(
        "Action not allowed. Only Hiring Managers can do this"
      );
    }
  };

  const updateApplicantProfileStatus = async (id, status, prevStatus) => {
    const data = { interview_stage: status };
    await dispatch(
      update_applicant_profile_status_kanboard_hiring_manager_action(id, data)
    );
    await callFilteredListApi(jobId, status);
    await callFilteredListApi(jobId, prevStatus);
  };

  const onViewApplicantProgressClick = (id) => {
    navigate(`/view-applicant-profile-dashboard/${id}`, {
      state: {
        applicantId: id,
        jobId: jobDetails?.data && jobDetails.data?.id,
      },
    });
  };

  const onAssignInterviewKit = async (id) => {
    setAssignInterviewkitLoading(true);
    await dispatch(
      assign_interview_kit_job_action(
        jobDetails?.data && jobDetails.data?.id,
        id
      )
    );
    callJobDetailsApi(jobDetails?.data?.id);
    setShowAllInterviewKits(false);
    setAssignInterviewkitLoading(false);
  };

  const openInterviewKit = async () => {
    setInterviewKitsLoading(true);
    setShowAllInterviewKits(!showAllInterviewKits);
    await dispatch(get_all_published_interview_kit_data_action());
    setInterviewKitsLoading(false);
  };

  const onViewCandidateProfileClick = (id) => {
    if (id) navigate(`/view-candidate-profile/${id}?job=`, { state: id });
  };
  const onJobShareClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    if (jobDetails?.data) {
      const url = isDev
        ? `http://localhost:3000/view-job-detail/${jobDetails?.data && jobDetails.data?.id
        }`
        : `${process.env.REACT_APP_DEV_ROOT_URL}/view-job-detail/${jobDetails?.data && jobDetails.data?.id
        }`;
      window.navigator.clipboard.writeText(url);

      showSuccessMessage(`Url copied ${url}`);
    }
  };

  const onSearch = () => {
    if (showSearch) {
      searchInputRef.current.value = "";
    }
    setShowSearch((showSearch) => !showSearch);
  };

  const onSearchInputChange = async (e, id) => {
    let value = e.target.value;
    if (value.length > 2) {
      setShowSearch(true);
      const data = {
        index: "candidate_job_application",
        search_key: "kanban-board",
        search: value,
        job_posting: id,
        skill_names: [],
      };
      setCandidateKanbanSearchLoading(true);
      await dispatch(search_candidate_kanban_board_user_action(data));
      setCandidateKanbanSearchLoading(false);
    } else if (value === "") {
      onSearch();
    }
  };

  const callAllAssignedCandidatesApi = async (id) => {
    setAssignedCandidatesLoading(true);
    const res = await dispatch(get_assigned_candidates_kanban_action(id));
    setAssignedCandidatesLoading(false);
  };

  const callEventListsApi = async () => {
    await dispatch(get_calendar_event_lists_action());
  };
  const onScheduleInterviewClick = async (id) => {
    await callEventListsApi();
    setscheduleInterviewModal((e) => !e);
  };

  const onCreateEventClick = () => {
    navigate("/create-event");
  };
  const onEventEditClick = (id) => {
    navigate(`/create-event/${id}`, { state: id });
  };

  const onAssignInterviewEventClick = async (id) => {
    const data = {
      job_posting: jobId,
      event: id,
    };
    const res = await dispatch(assign_event_to_job_action(data));
    if (res.data) {
      let job_id = location.state.id;

      if (job_id !== null) {
        getAssignedInterviewkit(job_id);
        callJobDetailsApi(job_id);
        callAllAssignedCandidatesApi(job_id);
      }
      setscheduleInterviewModal(false);
    }
  };

  const onAssessmentFilterChange = async (e) => {
    let filter = e.target.value;

    let data = {
      ...columns,
      assessment: {
        ...columns.assessment,
        loading: true,
      },
    };
    setColumns(data);

    let filteredVal = assessmentValues.filter((item) =>
      filter === "Submitted"
        ? item.assessment_kit_submitted_details[0]?.interview_submitted === true
        : filter === "Accepted"
          ? item?.assessment_kit_details[0]?.kit_accepted &&
          item.assessment_kit_submitted_details.length === 0
          : filter === "Declined"
            ? item?.assessment_kit_details[0]?.kit_declined &&
            item.assessment_kit_submitted_details.length === 0
            : filter === "Pending"
              ? item?.assessment_kit_details.length === 0
              : item
    );
    data = {
      ...columns,
      assessment: {
        ...columns.assessment,
        items: filteredVal,
        loading: false,
      },
    };
    setColumns(data);
  };

  const onInterviewFilterChange = async (e) => {
    let filter = e.target.value;

    let data = {
      ...columns,
      interview: {
        ...columns.interview,
        loading: true,
      },
    };
    setColumns(data);

    let filteredVal = interviewValues.filter((item) =>
      filter === "Scheduled"
        ? item?.interview_details.length
        : filter === "Completed"
          ? item?.interview_details.length &&
          item.interview_details[0]?.room_videos.length
          : filter === "Pending"
            ? item?.interview_details.length === 0
            : item
    );
    data = {
      ...columns,
      interview: {
        ...columns.interview,
        items: filteredVal,
        loading: false,
      },
    };
    setColumns(data);
  };

  const onOfferFilterChange = async (e) => {
    let filter = e.target.value;

    let data = {
      ...columns,
      offer: {
        ...columns.offer,
        loading: true,
      },
    };
    setColumns(data);

    let filteredVal = offerValues.filter((item) =>
      filter === "Accepted"
        ? item?.job_offer_details?.offer_accepted === true
        : filter === "Rejected"
          ? item?.job_offer_details?.offer_rejected === true
          : filter === "Pending"
            ? item?.job_offer_details?.id === undefined ||
            (item?.job_offer_details?.offer_rejected === false &&
              item?.job_offer_details?.offer_accepted === false)
            : item
    );
    data = {
      ...columns,
      offer: {
        ...columns.offer,
        items: filteredVal,
        loading: false,
      },
    };
    setColumns(data);
  };

  const onToggleViewClick = () => {
    setToggleView(!toggleView);
    setListView(!listView);
  }

 const changeStageHandler = async (data) => {
    let jobApplication = data?.job_posting;
    let candidateID = data?.id;
    let hiringStage = data && data.interview_stage;
    let FormData = {};
    if (hiringStage === "applied") {
      FormData = { ...FormData, interview_stage: "assessment" };
    } else if (hiringStage === "assessment") {
      FormData = { ...FormData, interview_stage: "interview" };
    } else if (hiringStage === "interview") {
      FormData = { ...FormData, interview_stage: "offer" };
    } else if (hiringStage === "offer") {
      FormData = { ...FormData, interview_stage: "hired" };
    }

    setStageLoading(true);
    await dispatch(
      update_applicant_profile_status_kanboard_hiring_manager_action(
        candidateID,
        FormData
      )
    );

    callCandidateListApi(jobApplication , currentTab);
    setStageLoading(false);
  };

  return {
    columns,
    loading,
    jobDetails,
    allInterviewKits,
    showAllInterviewKits,
    suggestedCandidates,
    suggestedCandidatesLoading,
    assignedInterviewKit,
    interviewKitsLoading,
    candidateKanbanSearch,
    showSearch,
    searchInputRef,
    candidateKanbanSearchLoading,
    assignedCandidates,
    assignedCandidatesLoading,
    toggleView,
    candidatesList,
    stageLoading,
    userType,
    listView,
    setLastElement,
    onViewApplicantProgressClick,
    onAssignInterviewKit,
    openInterviewKit,
    onDragEnd,
    onViewCandidateProfileClick,
    onSearch,
    onSearchInputChange,
    onJobShareClick,

    onAssignInterviewEventClick,
    onScheduleInterviewClick,
    onCreateEventClick,
    onEventEditClick,
    scheduleInterviewModal,
    calendarEventLists,
    onOfferFilterChange,
    onAssessmentFilterChange,
    onInterviewFilterChange,
    onToggleViewClick,
    currentTabHandler,
    changeStageHandler
  };
}

export default useApplicantKanboard;
